import { AdminClientBuilder } from './adminClient-builder';
import { AdminInvoiceProfileBuilder } from './adminInvoiceProfile-builder';
import { AgencyBuilder } from './agency-builder';
import * as _ from 'lodash-es';
import { AdminReservation } from '../model/adminReservation';
import { AdminReservationList } from '../model/adminReservation-list';
import { AdminCompanyBuilder } from './adminCompany-builder';
import { AdminReservationExtraBuilder } from './adminReservationExtra-builder';
import { AdminProductBuilder } from './adminProduct-builder';
import { AdminKeySpaceInformationBuilder } from './adminKeySpaceInformation-builder';
import { AdminUserBuilder } from './adminUser-builder';
import { FlightStatsBuilder } from './flight-stats-builder';
import { MechanicalOrderBuilder } from './mechanical-order-builder';
export class AdminReservationBuilder {
    static buildAdminReservation(data) {
        let adminReservation = new AdminReservation();
        adminReservation.id = data.id;
        adminReservation.id_agency = data.id_agency;
        adminReservation.hash = data.reservation_hash;
        adminReservation.agency_name = data.agency_name || null;
        adminReservation.id_company = data.id_company;
        adminReservation.company_name = data.company_name || null;
        adminReservation.id_client_origin = data.id_client_origin;
        adminReservation.id_client = data.id_client;
        adminReservation.id_bill = data.id_bill == 0 ? null : data.id_bill;
        adminReservation.id_image_in_signature = data.id_image_in_signature;
        adminReservation.id_invoice_profile = data.id_invoice_profile;
        adminReservation.id_lot = data.id_lot;
        adminReservation.id_paymethod = data.id_paymethod;
        adminReservation.id_product = data.id_product;
        adminReservation.id_product_option = data.id_product_option;
        adminReservation.id_parkcloud = data.id_parkcloud;
        adminReservation.id_promotion = data.id_promotion;
        adminReservation.id_sale = data.id_sale;
        adminReservation.id_vehicle = data.id_vehicle;
        adminReservation.vehicle = data.vehicle;
        adminReservation.id_wash = data.id_wash;
        adminReservation.id_mechanical_orders = data.id_mechanical_orders;
        adminReservation.record = data.record;
        adminReservation.ship = data.ship;
        adminReservation.space_number = data.space_number;
        adminReservation.status = data.status;
        adminReservation.aena = data.aena;
        adminReservation.baggage = data.baggage;
        adminReservation.base_additional = data.base_additional;
        adminReservation.base_standard = data.base_standard;
        adminReservation.base_trans = data.base_trans;
        adminReservation.booking_calc_json = data.booking_calc_json;
        adminReservation.booking_date = data.booking_date;
        adminReservation.booking_id_via = data.booking_id_via;
        adminReservation.booking_pvp_agency = data.booking_pvp_agency;
        adminReservation.booking_pvp_total = data.booking_pvp_total;
        adminReservation.booking_via = data.booking_via;
        adminReservation.calle = data.calle;
        adminReservation.driver = data.driver;
        adminReservation.email = data.email;
        adminReservation.lang = data.lang;
        adminReservation.in_calc_json = data.in_calc_json;
        adminReservation.in_date = data.in_date;
        adminReservation.in_date_expected = data.in_date_expected;
        adminReservation.in_extra = data.in_extra;
        adminReservation.in_passengers = data.in_passengers;
        adminReservation.in_terminal = data.in_terminal;
        adminReservation.out_date_requested = data.out_date_requested;
        adminReservation.out_date = data.out_date;
        adminReservation.out_date_expected = data.out_date_expected;
        adminReservation.out_extra = data.out_extra;
        adminReservation.out_passengers = data.out_passengers;
        adminReservation.out_terminal = data.out_terminal;
        adminReservation.invoice_address = data.invoice_address;
        adminReservation.invoice_city = data.invoice_city;
        adminReservation.invoice_email = data.invoice_email;
        adminReservation.invoice_name = data.invoice_name;
        adminReservation.invoice_nif = data.invoice_nif;
        adminReservation.invoice_requested = data.invoice_requested;
        adminReservation.invoice_state = data.invoice_state;
        adminReservation.invoice_zip = data.invoice_zip;
        adminReservation.invoice_country = data.invoice_country;
        adminReservation.is_forced_date = data.is_forced_date;
        adminReservation.is_in_reminder_sent = data.is_in_reminder_sent;
        adminReservation.is_out_reminder_sent = data.is_out_reminder_sent;
        adminReservation.notes = data.notes;
        adminReservation.num_days = data.num_days;
        adminReservation.num_minutes = data.num_minutes;
        adminReservation.payment_amount = data.payment_amount;
        adminReservation.phone = data.phone;
        adminReservation.zip = data.zip;
        adminReservation.plate = data.plate;
        adminReservation.points_neo = data.points_neo;
        adminReservation.points_requested = data.points_requested;
        adminReservation.premium_checkin_agent_arrive_timestamp = data.premium_checkin_agent_arrive_timestamp;
        adminReservation.premium_checkout_agent_arrive_timestamp = data.premium_checkout_agent_arrive_timestamp;
        adminReservation.premium_checkin_car_in_base_timestamp = data.premium_checkin_car_in_base_timestamp;
        adminReservation.premium_checkin_car_in_base_user_id = data.premium_checkin_car_in_base_user_id;
        adminReservation.premium_checkout_car_picked_timestamp = data.premium_checkout_car_picked_timestamp;
        adminReservation.premium_in_car_fuel_level = data.premium_in_car_fuel_level;
        adminReservation.premium_in_car_km = data.premium_in_car_km;
        adminReservation.premium_out_car_fuel_level = data.premium_out_car_fuel_level;
        adminReservation.premium_out_car_km = data.premium_out_car_km;
        adminReservation.premium_status_timestamp = data.premium_status_timestamp;
        adminReservation.premium_status = data.premium_status;
        adminReservation.premium_checkin_parked_user_id = data.premium_checkin_parked_user_id;
        adminReservation.premium_checkout_car_picked_user_id = data.premium_checkout_car_picked_user_id;
        adminReservation.premium_checkin_request_timestamp = data.premium_checkin_request_timestamp;
        adminReservation.premium_checkin_start_timestamp = data.premium_checkin_start_timestamp;
        adminReservation.premium_checkin_parked_timestamp = data.premium_checkin_parked_timestamp;
        adminReservation.premium_checkin_user_id = data.premium_checkin_user_id;
        adminReservation.premium_checkout_request_timestamp = data.premium_checkout_request_timestamp;
        adminReservation.premium_checkout_start_timestamp = data.premium_checkout_start_timestamp;
        adminReservation.premium_checkout_user_id = data.premium_checkout_user_id;
        adminReservation.premium_checkout_vehicle_observations = data.premium_checkout_vehicle_observations;
        adminReservation.premium_checkout_vehicle_status = data.premium_checkout_vehicle_status;
        adminReservation.premium_checkout_agent_pick_parking_ticket_timestamp = data.premium_checkout_agent_pick_parking_ticket_timestamp;
        adminReservation.premium_checkout_agent_renew_parking_ticket_timestamp = data.premium_checkout_agent_renew_parking_ticket_timestamp;
        adminReservation.product_promotion_name = data.product_promotion_name;
        adminReservation.pvp_additional = data.pvp_additional;
        adminReservation.pvp_product_dto = data.pvp_product_dto;
        adminReservation.pvp_product_option = data.pvp_product_option;
        adminReservation.pvp_product_points = data.pvp_product_points;
        adminReservation.pvp_product_promotion = data.pvp_product_promotion;
        adminReservation.pvp_promotion = data.pvp_promotion;
        adminReservation.pvp_product_raw = data.pvp_product_raw;
        adminReservation.pvp_product_std = data.pvp_product_std;
        adminReservation.pvp_product_total = data.pvp_product_total;
        adminReservation.pvp_product_trans = data.pvp_product_trans;
        adminReservation.pvp_total = data.pvp_total;
        adminReservation.calc_mode = data.calc_mode;
        adminReservation.pvp_wash = data.pvp_wash;
        adminReservation.pvp_double_space = data.pvp_double_space;
        adminReservation.pvp_mechanical_orders = data.pvp_mechanical_orders;
        adminReservation.pvp_mechanical_order_ferry = data.pvp_mechanical_order_ferry;
        adminReservation.pvp_extra_services = data.pvp_extra_services;
        adminReservation.vat_additional = data.vat_additional;
        adminReservation.vat_standard = data.vat_standard;
        adminReservation.vat_trans = data.vat_trans;
        adminReservation.was_cancelled = data.was_cancelled;
        adminReservation.was_rejected = data.was_rejected;
        adminReservation.was_timeout = data.was_timeout;
        adminReservation.wash_user = data.wash_user;
        adminReservation.wash_status = data.wash_status;
        adminReservation.space_type = data.space_type;
        adminReservation.id_key_space = data.id_key_space;
        adminReservation.premium_checkin_request_via_id = data.premium_checkin_request_via_id;
        adminReservation.premium_checkout_request_via_id = data.premium_checkout_request_via_id;
        adminReservation.id_image_out_signature = data.id_image_out_signature;
        adminReservation.client = data.client ? AdminClientBuilder.buildAdminClient(data.client) : null;
        adminReservation.user = data.user ? AdminUserBuilder.buildAdminUser(data.user) : null;
        adminReservation.agency = data.agency ? AgencyBuilder.buildAgency(data.agency) : null;
        adminReservation.invoice_profile = data.invoice_profile ? AdminInvoiceProfileBuilder.buildAdminInvoiceProfile(data.invoice_profile) : null;
        adminReservation.company = data.company ? AdminCompanyBuilder.buildAdminCompany(data.company) : null;
        adminReservation.flightstats_validation = data.flightstats_validation;
        adminReservation.flightstats = data.flightstats ? FlightStatsBuilder.buildFlightStats(data.flightstats) : undefined;
        adminReservation.extras = _.map(data.extras, (reservationExtra) => {
            return AdminReservationExtraBuilder.buildAdminReservationExtra(reservationExtra);
        });
        adminReservation.product_extras = data.product_extras;
        adminReservation.product = data.product ? AdminProductBuilder.buildAdminProduct(data.product) : null;
        adminReservation.key_space_information = data.key_space_information ? AdminKeySpaceInformationBuilder.buildAdminKeySpaceInformation(data.key_space_information) : null;
        adminReservation.client_satisfaction_score = data.client_satisfaction_score;
        adminReservation.reservation_survey_link = data.reservation_survey_link;
        adminReservation.pvp_mechanical_orders = data.pvp_mechanical_orders;
        adminReservation.mechanical_orders = data.mechanical_orders ? _.map(data.mechanical_orders, (mechanicalOrder) => {
            return MechanicalOrderBuilder.buildMechanicalOrder(mechanicalOrder);
        }) : null;
        adminReservation.keys_needed = data.keys_needed;
        if (data.id_mechanical_orders) {
            adminReservation.keys_needed = true;
        }
        adminReservation.mechanical_orders_modification_timestamp = data.mechanical_orders_modification_timestamp;
        adminReservation.travelling_for_work = data.travelling_for_work;
        return adminReservation;
    }
    static buildAdminReservationList(data) {
        const adminReservations = new AdminReservationList();
        adminReservations.page = data.page;
        adminReservations.pagination = data.pagination;
        adminReservations.total = data.total;
        adminReservations.totalPages = data.totalPages;
        adminReservations.reservations = (data.reservations) ? _.map(data.reservations, (adminReservation) => {
            return AdminReservationBuilder.buildAdminReservation(adminReservation);
        }) : null;
        return adminReservations;
    }
}
//# sourceMappingURL=adminReservation-builder.js.map